import PropTypes from 'prop-types';
import React from 'react';
import { AlertBlock } from './components/AlertBlock';
import { BigCtaBlock } from './components/BigCtaBlock';
import { CardItem } from './components/CardItem';
import { CardsBlock } from './components/CardsBlock';
import { CarouselImageItem } from './components/CarouselImageItem';
import { CarouselTextBlock } from './components/CarouselTextBlock';
import { ColumnsTextBlock } from './components/ColumnsTextBlock';
import { ContactFormBlock } from './components/ContactFormBlock';
import { Course } from './components/Course';
import { FigureItem } from './components/FigureItem';
import { FiguresBlock } from './components/FiguresBlock';
import { FormBlock } from './components/FormBlock';
import { HighlightBlock } from './components/HighlightBlock';
import { ImageGalleryBlock } from './components/ImageGalleryBlock';
import { ImageGalleryItem } from './components/ImageGalleryItem';
import { LanguageBlock } from './components/LanguageBlock';
import { LanguageCourseDetail } from './components/LanguageCourseDetail';
import { LanguageCourseDetailSection } from './components/LanguageCourseDetailSection';
import { LanguageItem } from './components/LanguageItem';
import { LargeCarouselImageHighlightBlock } from './components/LargeCarouselImageHighlightBlock';
import { LargeCarouselImageItem } from './components/LargeCarouselImageItem';
import { LeftyCardBlock } from './components/LeftyCardBlock';
import { LeftyCardItem } from './components/LeftyCardItem';
import { MapBlock } from './components/MapBlock';
import { MiniCardItem } from './components/MiniCardItem';
import { MiniCardLiteItem } from './components/MiniCardLiteItem';
import { MiniCardsBlock } from './components/MiniCardsBlock';
import { MiniCardsLiteBlock } from './components/MiniCardsLiteBlock';
import { ResourcesItemFile } from './components/ResourceItem';
import { ResourcesItemLink } from './components/ResourceItem';
import { ResourcesBlock } from './components/ResourcesBlock';
import { RoundCarouselBlock } from './components/RoundCarouselBlock';
import { RoundCarouselItem } from './components/RoundCarouselItem';
import { SmallCarouselImageHighlightBlock } from './components/SmallCarouselImageHighlightBlock';
import { SmallCarouselImageItem } from './components/SmallCarouselImageItem';
import { TableBlock } from './components/TableBlock';
import { TableCell } from './components/TableCell';
import { TableGroupBlock } from './components/TableGroupBlock';
import { TableHeading } from './components/TableHeading';
import { TableRow } from './components/TableRow';
import { TextBlock } from './components/TextBlock';
import { TextColumn } from './components/TextColumn';

const Components = {
  LanguageBlock,
  FiguresBlock,
  RoundCarouselBlock,
  HighlightBlock,
  MiniCardsLiteBlock,
  MiniCardsBlock,
  BigCtaBlock,
  LanguageItem,
  RoundCarouselItem,
  FigureItem,
  MiniCardLiteItem,
  MiniCardItem,
  TextBlock,
  ColumnsTextBlock,
  TextColumn,
  ResourcesBlock,
  ResourcesItemLink,
  ResourcesItemFile,
  LeftyCardBlock,
  LeftyCardItem,
  CardsBlock,
  CardItem,
  AlertBlock,
  LargeCarouselImageHighlightBlock,
  SmallCarouselImageHighlightBlock,
  CarouselTextBlock,
  CarouselImageItem,
  SmallCarouselImageItem,
  LargeCarouselImageItem,
  TableBlock,
  TableHeading,
  TableRow,
  TableCell,
  LanguageCourseDetail,
  LanguageCourseDetailSection,
  ImageGalleryBlock,
  ImageGalleryItem,
  TableGroupBlock,
  Course,
  MapBlock,
  FormBlock,
  ContactFormBlock,
};

export const Instance = ({ instance, ...props }) => {
  if (typeof Components[instance?.meta?.class] !== 'undefined') {
    return React.createElement(Components[instance?.meta?.class], {
      key: instance?.meta?.class,
      data: instance,
      ...props,
    });
  }
  // component doesn't exist yet
  return React.createElement(
    () => (
      <div>The component {instance?.meta?.class} has not been created yet.</div>
    ),
    { data: instance },
  );
};

Instance.propTypes = {
  instance: PropTypes.shape({
    meta: PropTypes.shape({
      class: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
